import React, { Component } from 'react';
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css"
import Lightbox from 'react-images';

class LightBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentImage: 0
    };
    this.imageGallery = React.createRef();
  }

  openLightbox = () => {
    this.setState({
      currentImage: this.imageGallery.current.getCurrentIndex(),
      lightboxIsOpen: true,
    });
  }

  closeLightbox = () => {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false,
    });
  }

  gotoPrevious = () => {
    this.setState({
      currentImage: this.state.currentImage - 1,
    });
  }

  gotoNext = () => {
    this.setState({
      currentImage: this.state.currentImage + 1,
    });
  }

  renderImage = (item) => {
    return (
      <div className="image-gallery-image" style={{ backgroundImage: `url(${item.original})` }}></div>
    )
  }

  render() {
    return (
      <div className="photo-gallery">
        {this.props.carousel ?
          <ImageGallery ref={this.imageGallery} items={this.props.images} renderItem={this.renderImage}
            showThumbnails={false} showFullscreenButton={false} showPlayButton={false} /> :
          <img className="img-fluid mx-auto d-block" src={this.props.defaultImage} onClick={this.openLightbox} />
        }
        <Lightbox images={this.props.images}
          onClose={this.closeLightbox}
          onClickPrev={this.gotoPrevious}
          onClickNext={this.gotoNext}
          currentImage={this.state.currentImage}
          isOpen={this.state.lightboxIsOpen} />
        {this.props.carousel && <div className="row ml-0 mr-0 image-overlap">
          <div className="ml-auto" onClick={this.openLightbox}>View Photos<i className="fas fa-greater-than"></i></div>
        </div>}
      </div>
    )
  }
}

export default LightBox;
